module.exports = __webpack_public_path__ + "img/manufacturing-2.6cb82d6c.png";